import React from 'react'
import "./Booking.css"
import { Container } from "react-bootstrap"
import { Title } from "../../../../components"

const Booking = ({ pageData, url }) => {

  const bookingData = pageData?.templates?.find(template => template.section === "Booking Insights")?.data;


  return (
    <Container className='margin-top'>
        <div className='booking-container'>
          <img src={bookingData.booking_bg ? url + bookingData.booking_bg : require("../../../../assets/images/home/bg5.png")} className='booking-bg'/>
          <img src={bookingData.booking_bg_down ? url + bookingData.booking_bg_down : require("../../../../assets/images/home/bg7.png")} className='booking-bg-down'/>

            <div className='booking-content'>
              <div data-aos="fade-right" data-aos-duration="1500">
                <Title
                  desc={bookingData.booking_subtitle1}
                  title={bookingData.booking_title1}
                  para={bookingData.booking_desc1}
                  count={bookingData.booking_counter1}
                />
              </div>
            
              <div className='booking-image' data-aos="fade" data-aos-duration="1500">
                <img src={bookingData.booking_image ? url + bookingData.booking_image : require("../../../../assets/images/home/booking.png")} />
              </div>
              <div data-aos="fade-left" data-aos-duration="1500">
                <Title 
                  desc={bookingData.booking_subtitle2}
                  title={bookingData.booking_title2}
                  para={bookingData.booking_desc2}
                  count={bookingData.booking_counter2}
                />
              </div>
            </div>
            <div data-aos="fade-up" data-aos-duration="1500">
              <Title 
                desc={bookingData.booking_subtitle3}
                title={bookingData.booking_title3}
                para={bookingData.booking_desc3}
                count={bookingData.booking_counter3}
              />
            </div>
            
        </div>
    </Container>
  )
}

export default Booking